import React, { createContext, useContext, useState, useCallback } from 'react';

const ErrorContext = createContext({});

export const useError = () => {
  return useContext(ErrorContext);
};

/**
 * Error notification structure:
 * {
 *   id: string (unique identifier),
 *   timestamp: Date,
 *   message: string,
 *   details: string (optional),
 *   source: string (e.g., 'API', 'Firebase', etc.)
 * }
 */

export const ErrorProvider = ({ children }) => {
  const [errors, setErrors] = useState([]);

  const addError = useCallback((message, details = null, source = 'API') => {
    const error = {
      id: `${Date.now()}-${Math.random()}`,
      timestamp: new Date(),
      message,
      details,
      source
    };
    
    setErrors(prev => [error, ...prev]);
    
    // Log to console for debugging
    console.error(`[${source}] ${message}`, details || '');
    
    return error.id;
  }, []);

  const removeError = useCallback((errorId) => {
    setErrors(prev => prev.filter(err => err.id !== errorId));
  }, []);

  const clearAllErrors = useCallback(() => {
    setErrors([]);
  }, []);

  const value = {
    errors,
    addError,
    removeError,
    clearAllErrors,
    hasErrors: errors.length > 0
  };

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
};
